import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { animate } from './Apple';
import {Howl} from "howler"
import Lottie from 'lottie-react';
import AnimatedSubtitles from '../components/AnimatedSubtitles';
import { useTTSSubtitles } from '../hooks/useTTSSubtitles';
import './GameGUI.css';
import "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"

var confirm_callback
var timer_string
var quit_game_callback
var unpause_game_cb
var pause_game_cb

//helper function to animations
function animate_div(div_id, to_remove, to_add = "x", delay){
    window.setTimeout(()=>{
        if(to_remove != "none"){
            document.getElementById(div_id).classList.remove(to_remove)
        }
        document.getElementById(div_id).classList.add(to_add)
    }, delay)
}

/*
        Initialization
*/

export function gui_set_callbacks(cb_confirm_callback, cb_quit_callback, cb_pause, cb_unpause){
    confirm_callback = cb_confirm_callback
    quit_game_callback = cb_quit_callback

    unpause_game_cb = cb_unpause
    pause_game_cb = cb_pause

}

export function gui_intro(skip){
    if(skip){
        confirm_instructions()
    }
    else{
        animate_div("intro-container-top", "hidden", "fade-in", 1000)
        animate_div("intro-container-bot", "hidden", "fade-in", 2000)
        animate_div("intro-button-container", "hidden", "fade-in", 3000)
    
    
        window.setTimeout(()=>{
            if (window.sfx_dot) window.sfx_dot.play()
            window.setTimeout(()=>{
                if (window.sfx_dot) window.sfx_dot.play()
                window.setTimeout(()=>{
                    if (window.sfx_dot) window.sfx_dot.play()
                    const video = document.getElementById("instructions-vid-iframe");
                    if (video) {
                        // Try to play with sound first
                        video.play().catch(error => {
                            
                            // If autoplay fails, try muted
                            video.muted = true;
                            video.play().catch(err => {
                                console.error("Video playback failed, showing controls:", err);
                                // As last resort, show controls so user can manually play
                                video.controls = true;
                                video.muted = false;
                            });
                        });
                    }
                }, 1000)
            }, 1000)
        }, 1000)
    }
}

/*
        On Confirm Instructions
*/
export function confirm_instructions(){     
        if (window.sfx_button_click) window.sfx_button_click()

        animate_div("intro-game-logo-container","none","slide-out-L", 0)
        animate_div("instructions-vid-container","none","slide-out-L", 0)
        animate_div("intro-game-text-container","none","slide-out-R", 0)
        animate_div("intro-button-container","none","slide-out-R", 0)
        animate_div("intro-container","none",  "fade-out", 2000)
        const video = document.getElementById("instructions-vid-iframe");
        video.pause();

        window.setTimeout(()=>{
            if (window.sfx_start_2) window.sfx_start_2.play()

            if(confirm_callback){
                confirm_callback()
                animate_div("game-hud", "hidden", "fade-in", 0)

            }
        }, 3000)

}

function quit_game(){
    
    
    
    if(quit_game_callback){
        
        quit_game_callback()
    } else {
        console.error('🔴 quit_game_callback is not set! Check gui_set_callbacks.');
    }
}

function pause_game(){
    if (window.sfx_pause) window.sfx_pause.play()

    animate_div("game-hud", "none", "fade-out", 0)
    animate_div("pause-gui","hidden","fade-in", 500)

    if(pause_game_cb) pause_game_cb()
}

function unpause_game(){
    if (window.sfx_pause) window.sfx_pause.play()

    animate_div("game-hud", "fade-out", "fade-in", 500)
    animate_div("pause-gui","fade-in","fade-out", 0)
    animate_div("pause-gui","fade-out", "hidden", 1000)

    if(unpause_game_cb) unpause_game_cb()
}

export function show_gameover(){
    window.setTimeout(()=>{
        if (window.sfx_complete) window.sfx_complete.play()
    }, 1000)
    pause_game()
    animate_div("pause-quit-button", "none", "hidden")
    
    const continueButtonText = document.getElementById("pause-continue-button-text");
    const continueButton = document.getElementById("pause-continue-button");
    const infoCompleted = document.getElementById("pause-info-completed");
    
    if (continueButtonText) {
        continueButtonText.innerText = "Finish";
    }
    if (continueButton) {
        continueButton.onclick = quit_game;
    }
    if (infoCompleted) {
        infoCompleted.innerText = "Completed";
    }
}

/*
        On Gameover
*/
export function gui_gameover(max_rep, duration){
    return
    
    timer_string = secondsToMinutesSeconds(duration)

    document.getElementById("gameover").classList.add("fade-in")

    document.getElementById("main").classList.remove("fade-in")
    document.getElementById("main").classList.add("fade-out")
    document.getElementById("gameover-bubble").classList.remove("hidden")
    document.getElementById("gameover-bubble").classList.add("fade-in")

    document.getElementById("gameover-return").classList.remove("hidden")

    document.getElementById("gameover-return").classList.add("fade-in-delayed")
    
    document.getElementById("stats").innerText = `Completed ${max_rep} reps.`
    document.getElementById("duration").innerText = `Duration: ${timer_string} min`

}

/*
        TIMER STRING UPDATE CALLED BY MAIN GAME WINDOW
*/
export function gui_update_timer(seconds){
    timer_string = secondsToMinutesSeconds(seconds)
    const durationElement = document.getElementById("duration-text");
    if (durationElement) {
        durationElement.innerText = timer_string;
    }
}

function secondsToMinutesSeconds(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
  
    const minutesStr = String(minutes).padStart(2, '0');
    const secondsStr = String(remainingSeconds).padStart(2, '0');
  
    return `${minutesStr}:${secondsStr}`;
  }

/*
       INSTRUCTIONS LAYOUT
*/
const GameIntroLayout = ({ gameIconPath, gameAnimationPath, gameInstructionsText, gameLogoPath, gameInstructionsVid })=>{

    return(
        <div id ="intro-container" className = "border">

            <div id = "intro-container-left">
                <div id = "instructions-vid-container">
                    <div id = "instructions-vid-circle-mask">
                        <video
                        id = "instructions-vid-iframe"
                        src= {gameInstructionsVid}
                        title="Game instructions video"
                        playsInline
                        webkit-playsinline="true"
                        loop
                        preload="auto"
                        onError={(e) => {}}
                        />
                    </div>
                </div>
            </div>

            <div id = "intro-container-right">
                <div id = "intro-container-top" className = "border hidden">
                    <div id ="intro-game-logo-container" >
                        
                        <img id = "intro-game-logo-img" src = {gameLogoPath} key = {gameLogoPath}></img>

                    </div>
                    <div id ="intro-game-text-container" >
                        <p>
                        {gameInstructionsText}
                        </p>
                    </div>
                </div>
                <div id = "intro-container-bot" className = "border hidden">

                    <div id ="intro-button-container" className = "border hidden">
                        <button id = "intro-button" onClick={confirm_instructions}> 
                            <div id ="intro-button-contents">
                                <div id="intro-button-icon-play-container"><img id = "intro-button-icon-play" src="playbutton_red.svg"/></div>
                                <div><p>Play</p></div>
                            </div>
                        </button>
                    </div>

                </div>
            </div>
            
        </div> )
}

/*
        MAIN GAME UI LAYOUT
*/
const MainGUILayout = ({ gameIconPath})=>{
    const { isVisible, currentText, isAnimationActive } = useTTSSubtitles();
    const [mendyAnimation, setMendyAnimation] = useState(null);

    // Load Mendy animation
    useEffect(() => {
        const loadMendyAnimation = async () => {
            try {
                const response = await fetch('/dashboard/mendy-animation.json');
                if (response.ok) {
                    const animationData = await response.json();
                    setMendyAnimation(animationData);
                }
            } catch (error) {
                
            }
        };
        
        loadMendyAnimation();
    }, []);

    return(
        <div id = "game-hud" className = "hidden">

            <div id ="game-hud-left" className='border'>

                <div className = "game-hud-item-container border">
                    <button className="cancel border" onClick = {pause_game}>
                        
                    </button>
                </div>

                <div className = "game-hud-item-container border shift-left">
                        <div className="game-ui assignment-bubble l label-back border">
                            <div className = "game-hud-label-contents border">
                            <img id = "timer-icon-img" src = "timer_thin.svg"></img>
                                <p id = "duration-text" className = "game-info" >
                                ~    
                                </p>
                            </div>

                        </div>
                </div>

            </div>

            <div id ="game-hud-right" className='border'>
            <div className = "game-hud-item-container border shift-left">
                <div className="game-ui assignment-bubble r label-back border">
                    <div className = "game-hud-label-contents r-c border">
                        <img id = "timer-icon-img" src = {gameIconPath}></img>
                        <p id = "goal-text" className = "game-info">
                        00x
                        </p>
                    </div>
                </div>
                </div>
            </div>

            {/* Mendy Section with Animation and Subtitles */}
            <div id="game-hud-mendy-section" className={`mendy-container ${isAnimationActive ? 'speaking' : ''}`}>
                {/* Subtitles positioned LEFT of Lottie with slide-in effect */}
                <div className="mendy-subtitles-wrapper">
                    <AnimatedSubtitles
                        text={currentText}
                        isVisible={isVisible}
                        typingSpeed={30}
                        autoHideDuration={3000}
                        className="left-of-lottie"
                    />
                </div>
                
                {/* Lottie Animation - Always animated, visibility controlled */}
                <div className={`mendy-animation-wrapper ${isAnimationActive ? 'active' : 'inactive'}`}>
                    {mendyAnimation && (
                        <Lottie 
                            animationData={mendyAnimation}
                            loop={true}
                            autoplay={true}
                            style={{ width: "80px", height: "80px" }}
                            className="mendy-lottie"
                        />
                    )}
                </div>
            </div>

        </div>
        
    )
}

/*
    Pause screen layout
*/
export function setSummaryText(reps, timer){
    var timer_s = secondsToMinutesSeconds(timer)
    const repsElement = document.getElementById("pause-info-reps-text");
    const timeElement = document.getElementById("pause-info-time-text");
    
    if (repsElement) {
        repsElement.innerText = `${reps}`;
    }
    if (timeElement) {
        timeElement.innerText = `${timer_s}`;
    }
}

const PauseGUILayout = ({gameLogoPath})=>{
    return(
    <div id = "pause-gui" className = "hidden">

            <div id = "sound-toggle-container">
                <button id = "sound-toggle-button" className = "sound-on" onClick = {() => window.toggle_sound && window.toggle_sound()}></button>
            </div>

        <div id = "pause-panel-container">
            <div id = "pause-panel-container-top">




                <div id = "pause-info-container">

                    <div id ="pause-info-panel" className = "label-info-back game-ui">

                        <div id = "pause-game-header">
                            <div id = "pause-game-graphic-container">

                                <div id = "pause-game-graphic">
                                    <img src = {gameLogoPath} key = {gameLogoPath}></img>
                                </div>

                            </div>

                            <p id = "pause-info-h">
                            </p>

                        </div>


                        <div id = "pause-info-panel-text">
                            


                                <div className = "pause-info-row">
                                    <p className = "pause-info-label">Total Reps</p>
                                    <p id = "pause-info-reps-text">00</p>
                                </div>

                                <div className = "pause-info-row">
                                    <p className = "pause-info-label">Time</p>
                                    <p id = "pause-info-time-text">00</p>
                                </div>

                                <div className = "pause-info-row">
                                        <p id = "pause-info-completed" className = "pause-info-label centered">Incomplete</p>
                                </div>

                            </div>


                        
                    </div>

                </div>

            </div>


            <div id = "pause-panel-container-bot">
                <div id = "pause-quit-container">
                    <button id = "pause-quit-button" className = "cancel" onClick = {quit_game}></button>
                </div>
                <div id = "pause-continue-container">
                    <button id = "pause-continue-button" onClick = {unpause_game}>
                        <div id = "pause-continue-contents">
                            <div id="intro-button-icon-play-container">
                                <img id = "intro-button-icon-play" src="playbutton_red.svg"/>
                            </div>
                            <div><p id ="pause-continue-button-text">Resume</p></div>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
    )
}

/*
        GAME OVER UI LAYOUT
*/
const GameoverLayout = ()=>{
    return(
        <div id ="gameover">
            <div id = "gameover-bubble"
            className = "hidden game-ui">
            <img id = "gameover-doc-img" src="doc_clip4.svg"></img>
                        <p id = "gameover-text" >
                            Exercise complete!
                        </p>
                        <div id ="duration"></div>
                        <div id ="stats"></div>
            </div>
            <button className="game-ui hidden" id = "gameover-return" onClick={confirm_instructions}> 
            Return
            </button>
        </div>
    )
}

/*
        EXPORT
*/

export const GameHUD = () =>{

        const [gameIconPath, setGameIconPath] = useState('');
        const [gameAnimationPath, setGameAnimationPath] = useState('');
        const [gameInstructionsText, setGameInstructionsText] = useState('');
        const [gameLogoPath, setGameLogoPath] = useState('');
        const [gameInstructionsVid, setGameInstructionsVid] = useState('');
        
        // Add sound effects to component state
        const [soundContainer, setSoundContainer] = useState(null);
        const [soundOn, setSoundOn] = useState(true);

        // Initialize sound effects when component mounts
        useEffect(() => {
            const sounds = {
                sfx_start: new Howl({
                    src: ['sfx/Retro9.wav']
                }),
                sfx_start_2: new Howl({
                    src: ['sfx/Retro10.wav']
                }),
                sfx_dot: new Howl({
                    src: ['sfx/Modern2.wav']
                }),
                sfx_pause: new Howl({
                    src: ['sfx/Minimalist1.wav']
                }),
                sfx_complete: new Howl({
                    src: ['sfx/Retro7.wav']
                })
            };
            
            setSoundContainer(sounds);
            
            // Cleanup sounds when component unmounts
            return () => {
                Object.values(sounds).forEach(sound => {
                    if (sound && sound.unload) {
                        sound.unload();
                    }
                });
            };
        }, []);

        // Move sound functions into component scope
        const sfx_button_click = () => {
            if (soundContainer && soundContainer.sfx_start) {
                soundContainer.sfx_start.play();
            }
        };

        const toggle_sound = () => {
            if (soundOn) {
                Howler.mute(true);
                setSoundOn(false);
                document.getElementById("sound-toggle-button").classList.add("sound-off");
                document.getElementById("sound-toggle-button").classList.remove("sound-on");
            } else {
                Howler.mute(false);
                setSoundOn(true);
                document.getElementById("sound-toggle-button").classList.remove("sound-off");
                document.getElementById("sound-toggle-button").classList.add("sound-on");
            }
        };

        // Update the global functions to use component state
        useEffect(() => {
            // Override the global functions to use component state
            window.sfx_button_click = sfx_button_click;
            window.toggle_sound = toggle_sound;
            
            // Update the global sound functions to use component state
            window.sfx_start = soundContainer?.sfx_start;
            window.sfx_start_2 = soundContainer?.sfx_start_2;
            window.sfx_dot = soundContainer?.sfx_dot;
            window.sfx_pause = soundContainer?.sfx_pause;
            window.sfx_complete = soundContainer?.sfx_complete;
        }, [soundContainer]);

        // Set up game info callback
        useEffect(() => {
            window.gui_set_game_info = (game_type) => {
                setGameAnimationPath("instruction-animations/"+game_type.instructions);
                setGameIconPath("pip-icons/"+game_type.game_pip);
                setGameLogoPath("logos/"+game_type.game_icon);
                setGameInstructionsText(game_type.instructions_txt);
                setGameInstructionsVid(game_type.instructions_vid);
            };
        }, []);

        return(
        <div id="main">

        <style>
        @import url('https://fonts.googleapis.com/css2?family=Lexend+Exa:wght@100..900&display=swap');
        </style>

        
        <GameIntroLayout                
                gameIconPath={gameIconPath}
                gameAnimationPath={gameAnimationPath}
                gameInstructionsText={gameInstructionsText}
                gameLogoPath={gameLogoPath}
                gameInstructionsVid={gameInstructionsVid}
            />
        <PauseGUILayout gameLogoPath={gameLogoPath}/>
        <MainGUILayout gameIconPath={gameIconPath}/>
        

        </div>
    )
}

export default GameHUD;